import { render, staticRenderFns } from "./NewPresaleForm.vue?vue&type=template&id=67ca290c&scoped=true"
import script from "./NewPresaleForm.vue?vue&type=script&lang=js"
export * from "./NewPresaleForm.vue?vue&type=script&lang=js"
import style0 from "./NewPresaleForm.vue?vue&type=style&index=0&id=67ca290c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ca290c",
  null
  
)

export default component.exports